import type { Effect, Reducer } from 'umi';

import type { ProductDataType } from './data';
import { getProductDetail } from './service';

export interface StateType {
  product?: ProductDataType;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    get: Effect;
  };
  reducers: {
    save: Reducer<StateType>;
    clear: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'settingProductModel',
  state: {
    product: undefined,
  },
  effects: {
    *get({ payload }, { call, put }) {
      const response = yield call(getProductDetail, payload);
      yield put({
        type: 'save',
        payload: response.data,
      });
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        product: action.payload,
      };
    },
    clear() {
      return {
        product: undefined,
      };
    },
  },
};

export default Model;
